import { Outlet } from 'react-router-dom';

import Navigation from './Components/Navigation/Navigation';
import ScrollToTop from './Components/ScrollToTop';
import './style/base.css';
import './style/inputs.css';
import './style/reset.css';
import './style/table.css';
import './style/typography.css';
import './style/variables.css';

function App() {
  return (
    <div className="App">
      {' '}
      <ScrollToTop />
      <Navigation />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
}

export default App;
